// import { createStore, compose } from "redux";
import { createStore, applyMiddleware  } from "redux";
// import { routerMiddleware } from "connected-react-router";
// import createSagaMiddleware from "redux-saga";
import thunk from 'redux-thunk'
import createReducer from "./reducers/rootReducer";

// const sagaMiddleware = createSagaMiddleware();

export default function configureStore(initialState = {}, history = {}) {
  // Create the store with two middlewares
  // 1. sagaMiddleware: Makes redux-sagas work
  // 2. routerMiddleware: Syncs the location/URL path to the state
  // const middlewares = [sagaMiddleware, routerMiddleware(history)];

  // const enhancers = [applyMiddleware(...middlewares)];

  // If Redux DevTools Extension is installed use it, otherwise use Redux compose
  /* eslint-disable no-underscore-dangle */
  // const composeEnhancers =
  //   process.env.NODE_ENV !== "production" &&
  //   typeof window === "object" &&
  //   window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  //     ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
  //         // Prevent recomputing reducers for `replaceReducer`
  //         shouldHotReload: false,
  //       })
  //     : compose;
  /* eslint-enable */

  const store = createStore(createReducer(), applyMiddleware(thunk));

  // Extensions
  // store.runSaga = sagaMiddleware.run;
  store.injectedReducers = {}; // Reducer registry
  store.injectedSagas = {}; // Saga registry

  return store;
}
